import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=089fd4c6"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"
import style0 from "./MediaItem.vue?vue&type=style&index=0&id=089fd4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports